<!-- 微信立减金微信环境外跳转微信小程序 -->
<template>
    <div></div>
</template>
<script>
export default {
    name: 'WechatDiscount',
    data() {
        return {
        }
    },
    mounted() {
        this.jumpToWechatDiscount()
    },
    methods: {
        jumpToWechatDiscount() {
            if (this.isWechat()) {
              window.location.href = 'https://mapa.quancangyun.cn/ydsh-pq-h5-redeem-code/#/exchangeCodeNew'
            } else {
                const appid = 'wx34cd5e285f2a0813'
                const weappUrl = 'pages/exchangeCodeNewContainer/index'
                const path = `weixin://dl/business/?appid=${appid}&path=${weappUrl}`
                window.location.href = path
            }

        },
        // 判断当前环境是否是微信环境 true为微信环境
        isWechat() {
            const ua = navigator.userAgent.toLowerCase()
            return ua.includes('micromessenger')
        }
    }
}
</script>